import src from "IMAGE";
export default { src, width: 248, height: 165, blurWidth: 0, blurHeight: 0};
